(() => {
  'use strict';
  const ui = JSON.parse(document.getElementById('CozivaUI')?.textContent || '{}');
  const labels = ui.labels || {};
  const root = (ui.root || '/').replace(/\/?$/, '/');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:ui.currency || 'USD'}).format(cents / 100);
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const drawer = document.querySelector('.cart-drawer');
  let cartBusy = false;
  let returnFocus;
  let initialGiftCleanup = Promise.resolve();
  const isRemovedGift = item => item.handle === 'catnip-play-toy' || String(item.properties?._coziva_gift) === 'true';
  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(el => {el.textContent=cart.item_count;el.hidden=cart.item_count===0;});
  }
  async function removeRetiredGifts(cart) {
    const gifts=cart.items.filter(isRemovedGift);
    if (!gifts.length) return cart;
    const updates=Object.fromEntries(gifts.map(item=>[item.key,0]));
    return api('cart/update.js',{updates,sections:['cv-cart-render']});
  }
  async function cleanCurrentCart() {
    try {await initialGiftCleanup;} catch { /* Retry a previously failed cleanup before proceeding. */ }
    return removeRetiredGifts(await api('cart.js'));
  }


  async function api(path, body) {
    const response = await fetch(root + path, {method:body ? 'POST' : 'GET',headers:{'Content-Type':'application/json','Accept':'application/json'},...(body ? {body:JSON.stringify(body)} : {})}).catch(()=>{throw Error(labels.cart_network_error || labels.error);});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw Error(typeof data.description === 'string' ? data.description : labels.error);
    return data;
  }
  function openDialog(dialog) {
    if (!dialog?.open) { returnFocus = document.activeElement; dialog.showModal(); }
  }
  function closeDialog(dialog) { dialog?.close(); returnFocus?.focus?.(); }
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) closeDialog(dialog);
    });
    dialog.addEventListener('close', () => returnFocus?.focus?.());
  });
  function cartLines(sections) {
    const html=sections?.['cv-cart-render'];
    return html && new DOMParser().parseFromString(html,'text/html').querySelector('[data-cart-lines]');
  }
  function paintCart(cart,rendered) {
    updateCartCount(cart);
    drawer.querySelector('[data-drawer-count]').textContent='('+cart.item_count+')';
    drawer.querySelector('.cart-bottom').hidden=cart.item_count===0;
    drawer.querySelector('.cart-free-shipping').hidden=cart.item_count===0;
    const items=drawer.querySelector('.cart-items');
    let regularTotal=0;
    if (!cart.item_count) {
      items.innerHTML='<div class="cart-empty-state">'+(document.getElementById('CatteryEmptyArt')?.innerHTML || '')+'<p>'+esc(labels.cart_empty)+'</p><a class="button" href="'+esc(labels.catalog_url || root+'collections/all')+'">'+esc(labels.cart_empty_button)+'</a></div>';
    } else {
      if (!rendered) throw Error(labels.error);
      items.innerHTML=rendered.innerHTML;
      regularTotal=Number(rendered.dataset.regularTotal);
    }
    drawer.querySelector('[data-cart-total]').textContent=money(cart.total_price);
    const saving=Math.max(0,regularTotal-cart.total_price);
    drawer.querySelector('[data-cart-savings]').textContent='−'+money(saving);
    drawer.querySelector('[data-savings-row]').hidden=saving===0;
    const wallets=drawer.querySelector('[data-cart-wallets]');
    if (wallets) {
      const source=rendered?.ownerDocument.querySelector('template[data-cart-wallet-source]');
      wallets.replaceChildren(...(cart.item_count && source ? [source.content.cloneNode(true)] : []));
      wallets.hidden=!wallets.children.length;
    }
    drawer.querySelector('.cart-error').hidden=true;
    drawer.removeAttribute('aria-busy');
  }
  async function renderCart(cart) {
    cart=await removeRetiredGifts(cart);
    const rendered=cart.item_count ? cartLines(cart.sections || await api('?sections=cv-cart-render')) : null;
    paintCart(cart,rendered);
  }
  async function renderCartSections(sections) {
    const rendered=cartLines(sections);
    if (!rendered || !rendered.hasAttribute('data-total-price') || !rendered.hasAttribute('data-item-count')) return false;
    if (rendered.dataset.hasRetired==='true') { await renderCart(await cleanCurrentCart()); return true; }
    const cart={total_price:Number(rendered.dataset.totalPrice),item_count:Number(rendered.dataset.itemCount)};
    if (!Number.isFinite(cart.total_price) || !Number.isFinite(cart.item_count)) return false;
    paintCart(cart,rendered);
    return true;
  }
  function loadingCart() {
    drawer.setAttribute('aria-busy','true');
    drawer.querySelector('.cart-error').hidden=true;
    drawer.querySelector('.cart-bottom').hidden=true;
    drawer.querySelector('.cart-free-shipping').hidden=true;
    drawer.querySelector('.cart-items').innerHTML='<p class="cart-loading" role="status">'+esc(labels.cart_loading || labels.loading)+'</p>';
    openDialog(drawer);
  }
  function cartFailure(message) {
    drawer.removeAttribute('aria-busy');
    drawer.querySelector('.cart-items').innerHTML='<div class="cart-load-error"><a class="button" href="'+esc(root+'cart')+'">'+esc(labels.cart_view)+'</a></div>';
    const output=drawer.querySelector('.cart-error');
    output.textContent=message || labels.error;output.hidden=false;
  }
  async function showCart() {
    if (cartBusy) { openDialog(drawer); return; }
    cartBusy=true;loadingCart();
    try {
      await initialGiftCleanup;
      if (!await renderCartSections(await api('?sections=cv-cart-render'))) await renderCart(await cleanCurrentCart());
    } catch(error) { cartFailure(error.message); }
    finally { cartBusy=false; }
  }
  document.addEventListener('click', async event => {
    if (event.target.closest('[data-cart-open]')) { event.preventDefault(); await showCart(); }
    if (event.target.closest('[data-cart-close]')) closeDialog(drawer);
    if (event.target.closest('[data-menu-open]')) openDialog(document.querySelector('.mobile-menu'));
    if (event.target.closest('[data-menu-close]')) closeDialog(document.querySelector('.mobile-menu'));
    const change=event.target.closest('[data-line-change]');
    if (change && !cartBusy) {
      cartBusy=true; const wallets=drawer.querySelector('[data-cart-wallets]'); if(wallets)wallets.hidden=true; drawer.querySelectorAll('[data-line-change]').forEach(b=>b.disabled=true);
      try {
        const updates={[change.dataset.key]:Number(change.dataset.lineChange)};
        await renderCart(await api('cart/update.js',{updates,sections:['cv-cart-render']}));
      }
      catch (error) { const output=drawer.querySelector('.cart-error');output.textContent=error.message || labels.error;output.hidden=false; }
      finally {cartBusy=false;drawer.querySelectorAll('[data-line-change]').forEach(b=>b.disabled=false);}
    }
  });
  document.querySelectorAll('.mobile-menu a').forEach(a=>a.addEventListener('click',()=>closeDialog(a.closest('dialog'))));

  function productInit(section) {
    if (section.dataset.ready) return;
    section.dataset.ready='true';
    const data=JSON.parse(section.querySelector('.product-data')?.textContent || '{}');
    const variants=data.variants || [];
    const offers=[...section.querySelectorAll('.bundle-option')];
    let selected=section.querySelector('.bundle-option.is-selected') || offers[0];
    let adding=false;
    const output=section.querySelector('.product-error');
    const addButton=section.querySelector('[data-add-bundle]');
    const sticky=section.querySelector('.sticky-purchase');
    const optionsDialog=section.querySelector('.bundle-dialog');
    const optionsAdd=optionsDialog?.querySelector('[data-options-add]');
    function choicesFor(offer) {
      if (!offer) return [];
      return [...offer.querySelectorAll('.pair-choice')].map(row=>{
        const options=[...row.querySelectorAll('select')].map(select=>select.value);
        return variants.find(v=>v.options.every((value,index)=>value===options[index]));
      });
    }
    function syncPicker() {
      if (!optionsDialog) return;
      const clone=section.querySelector('.bundle-options').cloneNode(true);
      clone.querySelectorAll('[data-shopify-editor-block]').forEach(n=>n.removeAttribute('data-shopify-editor-block'));
      const clonedOffers=[...clone.querySelectorAll('.bundle-option')];
      clonedOffers.forEach((offer,index)=>{
        offer.querySelector('.bundle-summary').addEventListener('click',()=>{selectOffer(offers[index]);const active=optionsDialog.querySelector('.bundle-option.is-selected');active?.querySelector('.bundle-summary')?.focus();active?.scrollIntoView({block:'nearest'});});
        offer.querySelectorAll('select').forEach((select,choiceIndex)=>select.addEventListener('change',()=>{
          offers[index].querySelectorAll('select')[choiceIndex].value=select.value;
          output.hidden=true;updatePrices();
          optionsDialog.querySelectorAll('.bundle-option')[index]?.querySelectorAll('select')[choiceIndex]?.focus();
        }));
        offer.querySelectorAll('select').forEach((select,choiceIndex)=>{select.value=offers[index].querySelectorAll('select')[choiceIndex].value;});
      });
      optionsDialog.querySelector('.bundle-dialog-body').replaceChildren(clone);
      optionsDialog.querySelector('[data-options-total]').textContent=money(Number(selected?.dataset.total || 0));
    }
    function openOptions() {
      if (adding) return;
      syncPicker();openDialog(optionsDialog);
      optionsDialog.querySelector('.bundle-option.is-selected .bundle-summary')?.focus();
      optionsDialog.querySelector('.bundle-option.is-selected')?.scrollIntoView({block:'nearest'});
    }

    function updatePrices() {
      offers.forEach(offer=>{
        const choices=choicesFor(offer);
        const base=choices.reduce((sum,v)=>sum+(v?.price || 0),0);
        const compare=choices.reduce((sum,v)=>sum+Math.max(v?.compare_at_price || 0,v?.price || 0),0);
        const total=choices.reduce((sum,v)=>{const size=String(v?.options?.[0]||'').toLowerCase();const reduction=offer.dataset.discountMode==='size'?Number(labels['single_discount_'+size]||0):Number(offer.dataset.discount);return sum+Math.max(0,(v?.price||0)-Math.round(reduction*100));},0);
        offer.querySelector('[data-offer-total]').textContent=money(total);
        offer.querySelector('[data-offer-cart-total]').textContent=money(total);
        offer.querySelector('[data-offer-compare]').textContent=money(compare);
        offer.querySelector('[data-offer-savings]').textContent=money(Math.max(0,compare-total));
        const unitLine=offer.querySelector('[data-offer-unit]');
        if (unitLine) {
          const mixed=choices.some(v=>v?.price!==choices[0]?.price);
          const template=mixed ? section.dataset.averageLabel : section.dataset.unitLabel;
          unitLine.textContent=(template || '').replaceAll('[amount]',money(Math.round(total/Math.max(1,choices.length)))).replaceAll('[percent]',String(compare>0?Math.round(Math.max(0,compare-total)*100/compare):0));
          unitLine.hidden=!template;
        }
        offer.dataset.total=String(total);
        offer.querySelectorAll('.pair-choice').forEach((row,index)=>{const img=row.querySelector('img');const src=choices[index]?.featured_image?.src;if(img&&src){img.src=src;img.removeAttribute('srcset');}});
      });
      const choices=choicesFor(selected);
      const available=choices.length>0 && choices.every(v=>v?.available);
      addButton.disabled=!available || adding;
      addButton.textContent=adding ? labels.loading : (available ? labels.add : labels.sold_out);
      addButton.setAttribute('aria-busy',String(adding));
      if (sticky) {
        sticky.querySelector('[data-sticky-price]').textContent=money(Number(selected?.dataset.total || 0));
        const offerTitle=selected?.querySelector('.bundle-title strong')?.textContent || '';
        sticky.querySelector('[data-sticky-summary]').textContent=offerTitle+' · '+choices.map(v=>v?.options.join(' / ') || labels.choose_options).join(' · ');
        sticky.querySelector('[data-sticky-options]').disabled=adding;
        sticky.querySelector('[data-sticky-options]').setAttribute('aria-label',section.dataset.optionsLabel+' · '+sticky.querySelector('[data-sticky-price]').textContent+' · '+sticky.querySelector('[data-sticky-summary]').textContent);
        const stickyAdd=sticky.querySelector('[data-sticky-add]');
        stickyAdd.disabled=!available || adding;
        stickyAdd.textContent=adding ? labels.loading : (available ? labels.add : labels.sold_out);
        stickyAdd.setAttribute('aria-busy',String(adding));
      }
      if (optionsAdd) {
        optionsAdd.disabled=!available || adding;
        optionsAdd.textContent=adding ? labels.loading : (available ? labels.add : labels.sold_out);
        optionsAdd.setAttribute('aria-busy',String(adding));
        if (optionsDialog.open) syncPicker();
      }
    }
    function selectOffer(offer) {
      selected=offer;
      offers.forEach(o=>{const active=o===offer;o.classList.toggle('is-selected',active);o.querySelector('.bundle-summary').setAttribute('aria-checked',String(active));o.querySelector('.bundle-choices').hidden=!active;});
      output.hidden=true;updatePrices();
    }
    offers.forEach(offer=>{
      offer.querySelector('.bundle-summary').addEventListener('click',()=>selectOffer(offer));
      offer.querySelectorAll('select').forEach(select=>select.addEventListener('change',()=>{output.hidden=true;updatePrices();}));
    });
    async function add() {
      if (adding || cartBusy) return;
      output.hidden=true;
      const choices=choicesFor(selected);
      if (!choices.length || choices.some(v=>!v?.available)) {output.textContent=labels.sold_out;output.hidden=false;return;}
      const grouped=new Map();
      choices.forEach(v=>grouped.set(v.id,(grouped.get(v.id)||0)+1));
      const items=[...grouped].map(([id,quantity])=>({id,quantity}));
      adding=true;cartBusy=true;updatePrices();
      if (optionsDialog?.open) closeDialog(optionsDialog);
      loadingCart();
      let added=false;
      try {
        await initialGiftCleanup;
        const result=await api('cart/add.js',{items,sections:['cv-cart-render'],sections_url:location.pathname});
        added=true;
        if (!await renderCartSections(result.sections)) {
          const sections=await api('?sections=cv-cart-render');
          if (!await renderCartSections(sections)) await renderCart(await cleanCurrentCart());
        }
      } catch(error) {
        const message=added ? (labels.cart_refresh_error || labels.error) : (error.message || labels.error);
        output.textContent=message;output.hidden=false;cartFailure(message);
      } finally {adding=false;cartBusy=false;updatePrices();}
    }
    addButton.addEventListener('click',add);
    if (sticky) {
      sticky.querySelector('[data-sticky-options]').addEventListener('click',openOptions);
      sticky.querySelector('[data-sticky-add]').addEventListener('click',add);
      optionsAdd.addEventListener('click',add);
      optionsDialog.querySelector('[data-options-close]').addEventListener('click',()=>closeDialog(optionsDialog));
      const updateSticky=()=>{sticky.hidden=addButton.getBoundingClientRect().bottom>90;};
      const observer=new IntersectionObserver(updateSticky,{threshold:0,rootMargin:'-90px 0px 0px'});
      observer.observe(addButton);
      const stickyEvents=new AbortController();
      let stickyFrame;
      window.addEventListener('scroll',()=>{
        cancelAnimationFrame(stickyFrame);
        stickyFrame=requestAnimationFrame(updateSticky);
      },{passive:true,signal:stickyEvents.signal});
      window.addEventListener('resize',updateSticky,{signal:stickyEvents.signal});
      section.closest('.shopify-section')?.addEventListener('shopify:section:unload',()=>{
        stickyEvents.abort();observer.disconnect();cancelAnimationFrame(stickyFrame);
      },{once:true});
    }
    const requested=new URLSearchParams(location.search).get('variant');
    const requestedVariant=variants.find(v=>String(v.id)===requested);
    if (requestedVariant) offers.forEach(o=>o.querySelectorAll('.pair-choice').forEach(row=>row.querySelectorAll('select').forEach((s,index)=>s.value=requestedVariant.options[index])));
    selectOffer(selected);

    const inlineSize=section.querySelector('[data-inline-size-guide]');
    if (inlineSize) {
      const sizeBreakpoint=window.matchMedia('(min-width:750px)');
      const setSizeOpen=()=>{inlineSize.open=sizeBreakpoint.matches || inlineSize.dataset.mobileOpen==='true';};
      setSizeOpen();sizeBreakpoint.addEventListener('change',setSizeOpen);
      section.closest('.shopify-section')?.addEventListener('shopify:section:unload',()=>sizeBreakpoint.removeEventListener('change',setSizeOpen),{once:true});
    }
    const slides=[...section.querySelectorAll('.gallery-stage > .gallery-slide')];
    const thumbs=[...section.querySelectorAll('[data-thumb]')];
    const galleryDialog=section.querySelector('.gallery-dialog');
    section.querySelector('[data-thumbs-prev]')?.addEventListener('click',()=>section.querySelector('.gallery-thumbs').scrollBy({left:-250,behavior:'smooth'}));
    section.querySelector('[data-thumbs-next]')?.addEventListener('click',()=>section.querySelector('.gallery-thumbs').scrollBy({left:250,behavior:'smooth'}));
    let current=0;
    function show(index) {
      current=(index+slides.length)%slides.length;
      slides.forEach((slide,i)=>slide.hidden=i!==current);
      thumbs.forEach((thumb,i)=>thumb.setAttribute('aria-current',String(i===current)));
      if (galleryDialog.open) {
        const copy=slides[current].cloneNode(true);copy.hidden=false;copy.removeAttribute('data-slide');copy.removeAttribute('data-block-id');copy.removeAttribute('data-shopify-editor-block');copy.tabIndex=-1;
        galleryDialog.querySelector('.gallery-dialog-content').replaceChildren(copy);
      }
    }
    section.querySelector('[data-size-zoom]')?.addEventListener('click',event=>{
      const index=slides.findIndex(slide=>slide.dataset.blockId===event.currentTarget.dataset.sizeZoom);
      if (index>=0) {openDialog(galleryDialog);show(index);}
    });
    thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>show(i)));
    slides.forEach((slide,i)=>slide.addEventListener('click',()=>{openDialog(galleryDialog);show(i);}));
    galleryDialog.querySelector('[data-gallery-close]').addEventListener('click',()=>closeDialog(galleryDialog));
    galleryDialog.querySelector('[data-gallery-prev]').addEventListener('click',()=>show(current-1));
    galleryDialog.querySelector('[data-gallery-next]').addEventListener('click',()=>show(current+1));
    galleryDialog.addEventListener('keydown',event=>{if(event.key==='ArrowRight')show(current+1);if(event.key==='ArrowLeft')show(current-1);});
    section.addEventListener('shopify:block:select',event=>{
      const index=slides.findIndex(s=>s.dataset.blockId===event.detail.blockId);
      if(index>=0)show(index);
      const block=section.querySelector('[data-shopify-editor-block*="'+CSS.escape(event.detail.blockId)+'"]');
      if(block?.classList.contains('bundle-option'))selectOffer(block);
    });
  }
  function sectionInit(scope=document) {
    scope.querySelectorAll('[data-product-section]').forEach(productInit);
    scope.querySelectorAll('.anatomy-section').forEach(section=>{
      if(section.dataset.ready)return;section.dataset.ready='true';
      section.querySelectorAll('[data-hotspot]').forEach(button=>button.addEventListener('click',()=>{
        section.querySelectorAll('[data-hotspot]').forEach(b=>{const active=b===button;b.classList.toggle('active',active);b.setAttribute('aria-pressed',String(active));});
        section.querySelectorAll('[data-hotspot-panel]').forEach(p=>p.hidden=p.dataset.hotspotPanel!==button.dataset.hotspot);
      }));
    });
    scope.querySelectorAll('.shift-section').forEach(section=>{
      if(section.dataset.ready)return;section.dataset.ready='true';
      const buttons=[...section.querySelectorAll('[data-shift-tab]')];
      function select(button){buttons.forEach(b=>{b.setAttribute('aria-selected',String(b===button));b.tabIndex=b===button?0:-1;});section.querySelectorAll('[data-shift-panel]').forEach(p=>p.hidden=p.dataset.shiftPanel!==button.dataset.shiftTab);}
      buttons.forEach((button,index)=>{button.addEventListener('click',()=>select(button));button.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();const next=buttons[(index+(event.key==='ArrowRight'?1:buttons.length-1))%buttons.length];select(next);next.focus();});});
    });
    scope.querySelectorAll('.tracking-form').forEach(form=>{
      if(form.dataset.ready)return;form.dataset.ready='true';
      form.addEventListener('submit',event=>{event.preventDefault();const value=form.querySelector('input').value.trim();const error=form.querySelector('.tracking-error');error.hidden=!!value;if(!value)return;try{const url=new URL(form.dataset.provider+encodeURIComponent(value));if(url.protocol!=='https:')throw Error();window.open(url.href,'_blank','noopener,noreferrer');}catch{error.hidden=false;}});
    });
  }
  sectionInit();
  document.addEventListener('shopify:section:load',event=>sectionInit(event.target));
  const cartForm=document.querySelector('.cart-page-form');
  async function savePageCart(changed,remove=false,checkout=false){
    if(cartBusy)return;
    cartBusy=true;
    const lines=[...cartForm.querySelectorAll('[data-cart-key]')];
    const updates={};
    lines.filter(l=>l.dataset.gift!=='true').forEach(l=>{const input=l.querySelector('[data-cart-page-quantity]');const qty=remove&&l===changed.closest('[data-cart-key]')?0:Math.max(0,Number(input?.value||0));updates[l.dataset.cartKey]=qty;});
    lines.filter(l=>l.dataset.gift==='true').forEach(l=>updates[l.dataset.cartKey]=0);
    cartForm.querySelectorAll('.cattery-accelerated-checkout').forEach(e=>e.hidden=true);
    cartForm.querySelectorAll('button,input').forEach(e=>e.disabled=true);
    try{await cleanCurrentCart();const cart=await removeRetiredGifts(await api('cart/update.js',{updates}));if(checkout&&cart.item_count)location.assign(root+'checkout');else location.reload();}
    catch(error){const output=cartForm.querySelector('.cart-page-error');output.textContent=error.message||labels.error;output.hidden=false;cartBusy=false;cartForm.querySelectorAll('button,input').forEach(e=>e.disabled=false);}
  }
  cartForm?.addEventListener('input',event=>{if(event.target.matches('[data-cart-page-quantity]'))cartForm.querySelectorAll('.cattery-accelerated-checkout').forEach(e=>e.hidden=true);});
  cartForm?.addEventListener('submit',event=>{event.preventDefault();savePageCart(event.submitter,false,event.submitter?.name==='checkout');});
  cartForm?.querySelectorAll('[data-cart-page-remove]').forEach(link=>link.addEventListener('click',event=>{event.preventDefault();savePageCart(link,true);}));

  drawer.querySelector('form').addEventListener('submit',async event=>{
    event.preventDefault();if(cartBusy)return;cartBusy=true;
    const button=event.submitter||drawer.querySelector('[name="checkout"]');button.disabled=true;
    try{const cart=await cleanCurrentCart();if(cart.item_count)location.assign(root+'checkout');else await renderCart(cart);}
    catch(error){const output=drawer.querySelector('.cart-error');output.textContent=error.message||labels.error;output.hidden=false;}
    finally{cartBusy=false;button.disabled=false;}
  });
  if(ui.hasRemovedGifts){
    initialGiftCleanup=api('cart.js').then(removeRetiredGifts).then(cart=>{
      updateCartCount(cart);
      if(cartForm)location.reload();
    });
    initialGiftCleanup.catch(error=>{
      const output=cartForm?.querySelector('.cart-page-error')||drawer.querySelector('.cart-error');
      output.textContent=error.message||labels.error;output.hidden=false;
    });
  }
})();
